export default __webpack_public_path__ + "static/logo-pinterest-f30425e8e28313f85ac44930d54578c3.png";